const SupportStep = {
  SP1: "sp1",
  SP_ADDRESS: "spAddress",
  SP_CANCELLATION: "spCancellation",
  SP_LICENSE: "spLicense",
  SP_OTHER: "spOther",
  SP_REGISTRATION: "spRegistration",
  SP_USE: "spUse",
  SP_VEHICLE: "spVehicle",
  SP_COMPLETE: "spComplete",
};

export default SupportStep;
